import BoletimSection from "../BoletimSection/BoletimSection";
import CardDotGrid from "../CardDotGrid/CardDotGrid";
import styles from "../CardDotGrid/CardDotGrid.module.css";

function Ingles({ english }) {
	const defaultEnglish = {
		final_grade: "-",
		max_grade: "-",
		grades: [
			{
				title: "Listening",
				grade: 0,
				max_grade: 6,
			},
			{
				title: "Grammar",
				grade: 0,
				max_grade: 6,
			},
			{
				title: "Writing",
				grade: 0,
				max_grade: 6,
			},
			{
				title: "Speaking",
				grade: 0,
				max_grade: 6,
			},
		],
	};

	function isApproved(status) {
		if (
			status === "APPROVED" ||
			status === "TRACK 1" ||
			status === "TRACK 2"
		) {
			return true;
		} else {
			return false;
		}
	}

	function colorStyle(status) {
		if (status === "APPROVED") {
			return styles.approved;
		} else if (status === "TRACK 1" || status === "TRACK 2") {
			return styles.warning;
		} else {
			return styles.reproved;
		}
	}

	return (
		<BoletimSection
			title="Inglês"
			icon="english"
		>
			<CardDotGrid
				approved={english ? isApproved(english.status) : "default"}
				finalGrade={
					english ? english.final_grade : defaultEnglish.final_grade
				}
				maxGrade={
					english ? english.max_grade : defaultEnglish.max_grade
				}
				grades={english ? english.grades : defaultEnglish.grades}
				approvedText={english ? english.status : ""}
				reprovedText={english ? english.status : ""}
				customColorFunction={
					english ? () => colorStyle(english.status) : false
				}
				showIcon={false}
			/>
		</BoletimSection>
	);
}

export default Ingles;
